import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: ${(props) => props.theme['color.background']};
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Header = styled.header`
  flex: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 235px;
  background-color: #37bc9b;
  padding: 0 40px;

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    padding: 0 10px;
  }
`;

export const CourseTitle = styled.h1`
  font-size: 36px;
  line-height: 54px;
  color: #fff;
  font-weight: normal;
  line-height: 1.1;
`;

export const Content = styled.div`
  flex: 1;
  color: ${(props) => props.theme['color.text.body']};
  font-size: 14px;
  padding: 30px 40px;

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    padding: 30px 10px;
  }
`;

export const FullScreenDialogWrapper = styled.div`
 position: fixed;
 z-index: 8;
`;

export const StyledHeader = styled.header`
  text-transform: capitalize;
  font-size: 18px;
  font-weight: 600;
  line-height: 60px;
  margin-right: 16px;
`;